import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Container, Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import Font from '../../../../../SPRINTA/atoms/Font'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import BoxEvent from '../../../../../SPRINTA/molecules/BoxEvent'
import * as user from '../../../../utils/user'
import Button from '../../../../../SPRINTA/atoms/Button'

import T from '../../../../../SPRINTA/translate/T'


class Experiences extends Component {
   state = {
      loadingExperience: true,
      totalExperience: 0,
      loadingMore: false,
      dataExperience: [],
   }

   componentWillMount() {
      this.componentWillReceiveProps(this.props, true)   
   }

   componentWillReceiveProps(nextProps, force = false) {
      if(this.props.username !== nextProps.username || this.props.type !== nextProps.type || force) {
            this.loadDataExperience(nextProps.username, 0)
            this.setState({
                  loadingExperience: true
            })
      }
   }
   
   loadMoreData() {
      this.setState({
            loadingMore: true
      })

      this.loadDataExperience(this.props.username, this.state.dataExperience.length)
   }

   loadDataExperience(username, start = 0, limit = 12) {
      this.setState({
            loadingExperience: true
      })

      user.getExperience(username, start, limit)
      .then(data => {
         this.setState({
            loadingExperience: false,
            totalExperience: data.result.total,
            dataExperience: [
                  ...this.state.dataExperience,
                  ...data.result.list
            ],
            loadingMoreFuture: false
         })
      })
   }

   render() {
      if(this.state.loadingExperience)
      return(
         <Container>
            <Row>
               <Col>
                  <Placeholder type='retangle' style={{width: '200px', marginTop: '20px', height: '40px'}} />
                  <Row>
                     <Col size='12 4'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '150px'}} />
                     </Col>
                     <Col size='12 4'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '150px'}} />
                     </Col>
                     <Col size='12 4'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '150px'}} />
                     </Col>
                  </Row>
                  <br />
               </Col>
            </Row>
         </Container>
      )

      return (
         <Container style={{paddingBottom: '30px'}}>
            {this.state.dataExperience.length > 0 && (
                  <Row>
                        <Col>
                              <Row>
                                    <Col size='6'>
                                          <Font heading="3" color='#666' weight='100' style={{margin: '30px 0'}}>
                                          {T.text('experiences')}
                                          </Font>
                                    </Col>
                              </Row>
                              <Row>
                                    {this.state.dataExperience.map(item => (
                                          <Col size='12 4' key={item.id} style={{marginTop: '30px'}}>
                                                <a href={`/x/${item.friendlyUrl ? item.friendlyUrl : item.token}`}>
                                                      <BoxEvent
                                                            data={{
                                                                  cover: item.cover || null,
                                                                  type: 'experience',
                                                                  state_abbreviation: item.region,
                                                                  city: item.city,
                                                                  title: item.title,

                                                            }}
                                                      />
                                                </a>
                                          </Col>
                                    ))}
                              </Row>
                              {this.state.dataExperience.length < this.state.totalExperience && (
                                    <Col text='center' style={{marginTop: '30px'}}>
                                          {!this.state.loadingMore ? (
                                                <Button
                                                inline
                                                theme='primary'
                                                onClick={() => this.loadMoreData()}>
                                                      {T.txt('load_more')}
                                                </Button>
                                          ) : (
                                                <Loading />
                                          )}
                                    </Col>
                              )}
                        </Col>
                  </Row>
            )}

         </Container>
      )
   }
}

const mapStateToProps = store => ({
   user: store.user
})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Experiences)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Experiences/index.js